import React from "react";
import { ArrowLeftIcon, XIcon } from "@phosphor-icons/react";
import { Pressable, StyleSheet, View, type PressableStateCallbackType } from "react-native";

import type { ActivityDataInput } from "../../../../../components/customCoursework/ActivityForms/InteractiveLearningForm/InteractiveLearningFormCore";
import InteractiveLearningFormDataContainer from "../../../../../containers/customCoursework/InteractiveLearningForm/InteractiveLearningFormDataContainer";
import CustomText from "../../../../../components/common/general/CustomText/CustomText";
import { colors } from "../../../../../styles/design-system";
import type { ModernizerCreateActivityInput } from "./ModernizerAddActivityTypes";

interface ModernizerIleActivityFormProps {
  isSubmitting: boolean;
  onBack: () => void;
  onCancel: () => void;
  onSave: (input: ModernizerCreateActivityInput) => void;
}

const initialIleValues: ActivityDataInput = {};

function ModernizerIleActivityForm({ isSubmitting, onBack, onCancel, onSave }: ModernizerIleActivityFormProps) {
  const handleSave = (activityData: ActivityDataInput) => {
    onSave({
      type: "ile",
      input: activityData,
    });
  };

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <View style={styles.headerLeft}>
          <Pressable
            accessibilityRole="button"
            accessibilityLabel="Back to activity types"
            onPress={onBack}
            disabled={isSubmitting}
            style={({ hovered }: PressableStateCallbackType) => [styles.iconButton, hovered && styles.iconButtonHover]}>
            <ArrowLeftIcon size={18} color={colors.grey[700]} />
          </Pressable>
          <CustomText text="Create ILE" useTranslationText={false} size="l" weight="bold" style={styles.headerTitle} />
        </View>
        <Pressable
          accessibilityRole="button"
          accessibilityLabel="Close add activity"
          onPress={onCancel}
          disabled={isSubmitting}
          style={({ hovered }: PressableStateCallbackType) => [styles.iconButton, hovered && styles.iconButtonHover]}>
          <XIcon size={18} color={colors.grey[500]} />
        </Pressable>
      </View>
      <View style={styles.formBody}>
        <InteractiveLearningFormDataContainer
          activityData={initialIleValues}
          onSave={handleSave}
          onCancel={onCancel}
          isSubmitting={isSubmitting}
          imageGenerationSupportFlag={false}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    height: "100%",
    backgroundColor: colors.white,
  },
  header: {
    minHeight: 64,
    paddingHorizontal: 24,
    borderBottomWidth: 1,
    borderBottomColor: colors.grey[200],
    backgroundColor: colors.white,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  headerLeft: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    flex: 1,
  },
  headerTitle: {
    color: colors.grey[900],
  },
  iconButton: {
    width: 32,
    height: 32,
    borderRadius: 16,
    alignItems: "center",
    justifyContent: "center",
  },
  iconButtonHover: {
    backgroundColor: colors.grey[100],
  },
  formBody: {
    flex: 1,
    minHeight: 0,
  },
});

export default ModernizerIleActivityForm;
